module.exports = __webpack_public_path__ + "static/media/ASICS_Sportstyle_Logo.e3c4cfb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/pdf/templates/vlp/images/ASICS_Sportstyle_Logo.png
// module id = 281
// module chunks = 10